'use strict';

module.exports = '3.29.0';



/*****************
 ** WEBPACK FOOTER
 ** ./~/algoliasearch/src/version.js
 ** module id = 897
 ** module chunks = 0
 **/